import { vectors } from '@minware/ui-minware';
export const navBarItems = [
  {
    label: 'Product',
    heading: 'Product',
    separator: true,
    items: [
      {
        heading: 'Report Library',
        separator: true,
      },
      {
        label: 'Agile Scorecard',
        link: '/report/sprint-best-practices',
        icon: vectors.listCheck,
      },
      {
        label: 'Project Cost Allocation',
        link: '/report/project-cost-allocation',
        icon: vectors.barChart,
      },
      {
        label: 'Browse All...',
        link: '/reports',
        icon: vectors.book,
      },
      {
        heading: 'Data Platform',
        separator: true,
      },
      {
        label: 'Code/Ticket Linking',
        link: '/stack/code-ticket-linking',
        icon: vectors.graphLink,
      },
      {
        label: 'Work Timeline',
        link: '/stack/time-attribution',
        icon: vectors.valueStream,
      },
      {
        label: 'Benchmarks',
        link: '/stack/benchmarks',
        icon: vectors.trophy,
      },
      {
        label: 'Custom Report Builder',
        link: '/org/demo/dashboard/ae061875-f72c-42a6-b999-ce54d9921df2',
        icon: vectors.lineChart,
      },
    ],
  },
  {
    label: 'Pricing',
    link: '/pricing?from=nav',
  },
  {
    label: 'Contact',
    link: '/contact?from=nav',
  },
  {
    label: 'Resources',
    heading: 'Resources',
    separator: true,
    items: [
      {
        label: 'Self-Guided Demo',
        link: '/docs/demo?from=nav',
      },
      {
        label: 'Documentation',
        link: '/docs',
      },
      /* TODO when ready: uncomment
      {
        label: 'Software Engineering Guide',
        link: '/guide',
      },
      */
      {
        label: 'Security & Privacy',
        link: '/docs/security',
      },
      {
        label: 'About',
        link: '/about',
      },
      {
        label: 'Blog',
        link: '/blog',
      },
    ],
  },
]